/* 
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
* Distributed under the TruVideo proprietary license. 
*/
import { useNavigate } from 'react-router-dom';
import WorkflowBuilder from '../components/WorkflowBuilder';
import apiClient from '../api/client';
import { toast } from 'react-toastify';

const WORKFLOWS_ROUTE = '/workflows';

const WorkflowCreate = () => {
  const navigate = useNavigate();

  const handleSave = async (data) => {
    // Strip UI-only and DB-only fields before sending to API
    const payload = {
      ...data,
      items: data.items.map(item => ({
        id: item.id,
        type: item.type,
        description: item.description,
        stepOrder: item.stepOrder,
        required: item.required,
        identifierFormat: item.identifierFormat,
        identifierConfig: item.identifierConfig,
        audioRequired: item.audioRequired,
        allowedFileType: item.allowedFileType,
        maxPhotos: item.maxPhotos,
        referenceMediaUrl: item.referenceMediaUrl
      })),
    };

    await apiClient.post(WORKFLOWS_ROUTE, payload);
    toast.success('Workflow created successfully');
    navigate(WORKFLOWS_ROUTE);
  };

  const handleCancel = () => {
    navigate(WORKFLOWS_ROUTE);
  };

  return (
    <WorkflowBuilder
      onSave={handleSave}
      onCancel={handleCancel}
    />
  );
};

export default WorkflowCreate;
